/* eslint-disable max-classes-per-file */
export class XmppClientError extends Error {
  original: unknown;

  errorCondition?: string | null;

  constructor(message: string, original = null as unknown) {
    super(message);
    this.name = 'XmppClientError';
    this.original = original;
  }
}

export class XmppAuthenticationError extends XmppClientError {
  constructor(message: string, original = null as unknown) {
    super(message, original);
    this.name = 'XmppAuthenticationError';
  }
}